import type { TextFieldProps } from '@mui/material';
import { useState, memo, forwardRef } from 'react';
import TextField from '../TextField';

export type TextAreaProps = {
    maxLength?: number
    defaultValue?: string
} & TextFieldProps

/**
 * we do nothing with ref as we use inputRef for material ui. can be removed with react 19
 * @param param0
 * @param ref
 * @returns
 */
const TextArea = (props: TextAreaProps, _ref): JSX.Element => {
    const [letters, setLetters] = useState<number>(props.defaultValue?.length || 0);

    const countLetters = ev => {
        setLetters(ev.target.value?.length);
        if (props.onChange) props.onChange(ev);
    };

    return <TextField
        multiline
        {...props}
        onChange={countLetters}
        inputProps={{ style: { resize: 'vertical' } }}
        helperText={(props.helperText || '') + (props.maxLength ? ` ${props.maxLength} / ${letters}` : '')}
    />;
};

export default memo(forwardRef(TextArea));
